/*global chrome*/

import { observer } from 'mobx-react';
import React from 'react';

const ProctorPause = observer(
  class ProctorPause extends React.Component {
    constructor() {
      super();

      this.checkConnectionAndApproval = this.checkConnectionAndApproval.bind(this);

      this.state = {
        proctorConnected: false,
        ghostRunning: false
      };
    }

    componentDidMount() {
      if(!this.props.automated) {
        this.checkConnectionAndApproval();
      }
      this.checkGhost();
    }

    componentDidUpdate() {
      const { button, nextStep, parent, skipProctorPause, statusClass, proctorApproved, automated } =
        this.props;

      if (statusClass === 'slide-active') {
        // Skip if not enabled
        if (skipProctorPause) {
          parent.nextStep();
          button.disabled = false;
          return;
        }

        parent.setState({
          next: nextStep
        });

        // Don't let the user continue if they haven't been approved
        if (automated) {
          button.disabled = !this.state.ghostRunning
        } else {
          button.disabled = !proctorApproved || !this.state.ghostRunning;
        }
      }
    }

    async checkConnectionAndApproval() {
      const { SessionStore } = this.props.store;
      const { proctorApproved, setProctorApproved } = this.props;
      setInterval(() => {
        chrome.runtime.sendMessage(
          SessionStore.extensionInfo.extensionId,
          { message: 'checkConnectionAndApproval' },
          response => {
            if (
              response.connectionStatus === 'true' &&
              this.state.proctorConnected !== true
            ) {
              this.setState({ proctorConnected: true });
            }
            if (response.approvalStatus === 'true' && proctorApproved !== true) {
              setProctorApproved(true);
            }
            if (
              response.connectionStatus === 'undefined' &&
              this.state.proctorConnected !== false
            ) {
              this.setState({ proctorConnected: false });
            }
            if (response.approvalStatus === 'undefined' && proctorApproved !== false) {
              setProctorApproved(false);
            }
          }
        );
      }, 1000);
    }

    async checkGhost() {
      const { MessageStore } = this.props.store;
      const ghostInterval = setInterval(()=> {
        if (MessageStore.ghostRunning) {
          clearInterval(ghostInterval);
          this.setState({ghostRunning: true})
        }
      }, 1000)
    }

    render() {
      const { statusClass, proctorApproved, automated } = this.props;
      const translation = this.props.translation.proctorPause;

      if(automated) {
        return (
          <div className={`panel panel--medium ${statusClass}`}>
          <h2 className="panel__title panel__title--alt">{translation.heading}</h2>

          <p>{translation.alt_body}</p>

          <div className="tally-loader">
            <div className="tally">
              <section>
                <strong className="tally__title">{translation.ghost}</strong>

                <span
                  className={`tally__status ${
                    this.state.ghostRunning ? 'completed' : 'in-progress'
                  }`}
                >
                  <span className="meta">{translation[status]}</span>
                </span>
              </section>
              </div>
          </div>
        </div>
        )
      };

      return (
        <div className={`panel panel--medium ${statusClass}`}>
          <h2 className="panel__title panel__title--alt">{translation.heading}</h2>

          <p>{translation.body}</p>

          <div className="tally-loader">
            <ol className="tally">
                <li key={1}>
                <strong className="tally__title">{translation.assigned}</strong>

                <span
                  className={`tally__status ${
                    this.state.proctorConnected ? 'completed' : 'in-progress'
                  }`}
                >
                  <span className="meta">{translation[status]}</span>
                </span>
              </li>
              <li key={2}>
                <strong className="tally__title">{translation.approved}</strong>

                <span
                  className={`tally__status ${
                    proctorApproved ? 'completed' : 'in-progress'
                  }`}
                >
                  <span className="meta">{translation[status]}</span>
                </span>
              </li>
              <li key={3}>
                <strong className="tally__title">{translation.ghost}</strong>

                <span
                  className={`tally__status ${
                    this.state.ghostRunning ? 'completed' : 'in-progress'
                  }`}
                >
                  <span className="meta">{translation[status]}</span>
                </span>
              </li>
            </ol>
          </div>
        </div>
      );
    }
  }
);

export default ProctorPause;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/ProctorPause.js